import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ArrowBackwardButton from 'components/ArrowBackwardButton';
import ArrowForwardButton from 'components/ArrowForwardButton';
import { useProviderSpecificConfiguration } from 'modules/appConfiguration/useProviderSpecificConfiguration';
import NextButton from './NextButton';

const DIRECTION = {
  FORWARD: 'FORWARD',
  BACKWARD: 'BACKWARD',
};

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    backgroundColor: ({ provider }) => (provider ? 'white' : '#f8f8f8'),
  },
  controls: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    touchAction: 'manipulation',
  },
  controlsContent: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: ({ provider }) => (provider ? 600 : 893),
  },
  nextButton: ({ provider }) => ({
    textAlign: 'center',
    width: '100%',
    paddingLeft: '5px',
    paddingRight: '5px',
    boxSizing: 'border-box',
    '& button': {
      fontSize: provider ? '16px' : 'unset',
      borderRadius: provider ? '14px' : 'unset',
    },
  }),
}));

/**
 * Bottom navigation for the questionnaire
 */
const QuestionnaireNavigator = (props) => {
  const { code: providerCode } = useProviderSpecificConfiguration();
  const classes = useStyles({ provider: !!providerCode });
  const {
    handleSkipButton,
    handlePreviousButton,
    disablePreviousButton,
    disableSkipButton,
    shouldNextButtonBeShown,
    shouldSkipButtonBeShown,
  } = props;

  const handleChange = (direction) => () => {
    if (direction === DIRECTION.FORWARD) {
      // return dispatch(goToNextQuestion())
      return handleSkipButton();
    }

    // return dispatch(handlePreviousButton())
    return handlePreviousButton();
  };

  const nextButton = () => (
    <div className={classes.nextButton}>
      <NextButton />
    </div>
  );

  return (
    <div className={classes.root}>
      {shouldNextButtonBeShown && !providerCode ? nextButton() : null}
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems={providerCode ? 'center' : 'flex-start'}
        className={classes.controls}
      >
        <div className={classes.controlsContent}>
          <Grid item>
            <ArrowBackwardButton
              label="questionnaire.button.previous"
              onClick={handleChange(DIRECTION.BACKWARD)}
              isDisabled={disablePreviousButton}
            />
          </Grid>
          {providerCode && shouldNextButtonBeShown && (
            <Grid item>
              {nextButton()}
            </Grid>
          )}
          {shouldSkipButtonBeShown && (
            <Grid item>
              <ArrowForwardButton
                label="questionnaire.button.skip"
                onClick={handleChange(DIRECTION.FORWARD)}
                isDisabled={disableSkipButton}
              />
            </Grid>
          )}
        </div>
      </Grid>
    </div>
  );
};

QuestionnaireNavigator.propTypes = {
  shouldNextButtonBeShown: PropTypes.bool.isRequired,
  shouldSkipButtonBeShown: PropTypes.bool.isRequired,
  handleSkipButton: PropTypes.func,
  handlePreviousButton: PropTypes.func,
  disablePreviousButton: PropTypes.bool,
  disableSkipButton: PropTypes.bool,
};

export default QuestionnaireNavigator;
